module.exports = __webpack_public_path__ + "img/worksbot_img20021114.c14ea5b5.jpg";